import React from 'react';
import Pricing from '../components/sections/Pricing';
import PageHeader from '../components/ui/PageHeader';
import './StaticPage.css';

const PlansPage: React.FC = () => (
  <div className="static-page">
    <PageHeader page="plans" />
    <Pricing />
  </div>
);

export default PlansPage;
